export enum UserRole {
  ADMIN = 'admin',
  RESTAURANT_OWNER = 'restaurant_owner',
  CASHIER = 'cashier',
  WAITER = 'waiter',
  ACCOUNTANT = 'accountant',
  DELIVERY_CASHIER = 'delivery_cashier',
  INVENTORY_MANAGER = 'inventory_manager',
}

export enum AccountStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface User {
  id: string;
  username: string;
  email?: string;
  role: UserRole;
  restaurantId?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface LoginCredentials {
  emailOrUsername: string;
  password: string;
}

export interface AuthResponse {
  success: boolean;
  message?: string;
  data: {
    token: string;
    user: User;
  };
}

// Staff Management Types
export interface StaffMember {
  id: string;
  username: string;
  role: UserRole.CASHIER | UserRole.WAITER | UserRole.ACCOUNTANT | UserRole.DELIVERY_CASHIER | UserRole.INVENTORY_MANAGER;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateStaffDto {
  username: string;
  password: string;
  role: 'cashier' | 'waiter' | 'accountant' | 'delivery_cashier' | 'inventory_manager';
}

export interface UpdateStaffDto {
  username?: string;
  password?: string;
  role?: 'cashier' | 'waiter' | 'accountant' | 'delivery_cashier' | 'inventory_manager';
  isActive?: boolean;
}
